import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

export default (error: unknown | Error) => {
  return (error as SentryGraphQLError)?.errorCode;
};
